import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {AgGridAngular} from "ag-grid-angular";
import {AsyncPipe} from "@angular/common";
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";
import {ContainerComponent} from "@coreui/angular";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {CharityPayoutsComponent} from "./charity-payouts.component";
import {GameService} from "../../services/game.service";

/**
 * Single scope-aware charity-payouts page, replacing the former cross-game / game-admin pair.
 * Scope comes from route data (`isCrossGame`): global scope shows the game picker; game scope
 * uses the active game. That same `isCrossGame` is forwarded to the shared CharityPayoutsComponent
 * (via gameSetter), so it must match the route's scope exactly (true global, false game).
 */
@Component({
  selector: 'app-charity-payouts-page',
  standalone: true,
  imports: [
    AgGridAngular,
    AsyncPipe,
    ChooseYourGameComponent,
    ContainerComponent,
    CharityPayoutsComponent
  ],
  templateUrl: './charity-payouts-page.component.html',
})
export class CharityPayoutsPageComponent {
  private route = inject(ActivatedRoute);
  private gameService: GameService = inject(GameService);

  protected isCrossGame = this.route.snapshot.data['isCrossGame'] === true;
  protected game: IGameQueryResult | null = this.isCrossGame ? null : this.gameService.activeGame();

  onGameChosen(chosenGameP: IGameQueryResult) {
    this.game = chosenGameP;
  }
}
